export default __webpack_public_path__ + "static/media/icon_success.71bd535e.svg";